import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const sidebarSelector = (state: RootState) => state.sidebar;

export const getIsCollapse = createSelector(
  sidebarSelector,
  (state) => state.isCollapse,
);

export const getIsMobileMenuOpen = createSelector(
  sidebarSelector,
  (state) => state.isMobileMenuOpen,
);

const maintenanceBannerSelector = (state: any) => state.maintenanceBanner;

export const getIsBannerVisible = createSelector(
  maintenanceBannerSelector,
  (state) => state.show,
);
